// extracted by mini-css-extract-plugin
export default {"why-us":"whyus_why-us__HCSQ9","quick-service":"whyus_quick-service__vr5yf"};